export function getProjectCoverLetter(title?: string | null): string {
  const [first] = Array.from((title || "").trim());
  return (first || "U").toUpperCase();
}
